import './App.css';
import Header from './Components/Header';
import TinderCards from './Components/TinderCards';
import Footer from './Components/Footer';

function App() {
  return (
    <>
    <Header/>

    <TinderCards/>

    <Footer/>
    </>
  );
}

export default App;